var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFairLogo2020Baby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 148.7 56.3",
    style: {
      enableBackground: "new 0 0 148.7 56.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#BFD7ED;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-116.88474,60.141609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "matrix(0.26458333,0,0,0.26458333,13.201221,-61.775891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path861",
    className: "st0",
    d: "M-597.1,35.5h-66.6V75h113.6v46.9h-113.6v79.4H-719V-11.3h121.9V35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path863",
    className: "st0",
    d: "M-473.6,164.4h-78.9l-12.7,36.9h-58.9l81-212.6h60.3l80.9,212.6h-59L-473.6,164.4z  M-488.3,122.3l-24.8-70.9l-24.8,70.9H-488.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path865",
    className: "st0",
    d: "M-157,201.3h-68.7l-52.7-81.8v81.8h-55.3V-11.3h85.9c10.6-0.2,21.1,1.5,31,5.2 c16.2,6,29,18.8,34.8,35.1c3,8.2,4.4,16.8,4.4,25.5c0,16.2-3.9,29.3-11.7,39.3c-7.8,10.1-19.3,16.9-34.5,20.4L-157,201.3z  M-278.6,83.7h10.3c10.9,0,19.3-2.2,25.1-6.8c6-4.6,9.3-11.9,8.9-19.4c0.4-7.5-2.8-14.8-8.8-19.4c-5.7-4.5-14.2-6.8-25.1-6.8 h-10.4L-278.6,83.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon867",
    className: "st0",
    points: "-414.3,-11.3 -414.3,96.1 -374.2,201.3 -359,201.3 -359,-11.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g896",
    transform: "matrix(0.26458333,0,0,0.26458333,116.88474,-60.139848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path888",
    className: "st1",
    d: "M121.9,46.8H55.3v39.5h113.6v46.9H55.3v79.4H0V0h121.9V46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path890",
    className: "st1",
    d: "M245.3,175.8h-78.9l-12.7,36.9H94.8L175.7,0H236l80.9,212.6h-59L245.3,175.8z M230.7,133.7 l-24.8-70.9L181,133.7H230.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path892",
    className: "st1",
    d: "M561.9,212.6h-68.7l-52.7-81.8v81.8h-55.3V0h85.9c10.6-0.2,21.1,1.5,31,5.2 c16.2,6,29,18.8,34.8,35.1c3,8.2,4.4,16.8,4.4,25.5c0,16.2-3.9,29.3-11.7,39.3c-7.8,10.1-19.3,16.9-34.5,20.4L561.9,212.6z  M440.4,95h10.3c10.9,0,19.3-2.2,25.1-6.8c6-4.6,9.3-11.9,8.9-19.4c0.4-7.5-2.8-14.8-8.8-19.4c-5.7-4.5-14.2-6.8-25.1-6.8h-10.4 L440.4,95z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon894",
    className: "st1",
    points: "359.9,212.6 359.9,0 304.7,0 304.7,107.4 344.7,212.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairLogo2020Baby);
export default __webpack_public_path__ + "static/media/FAIRLogo2020-baby.2829ebfa8847d4f5ab91484e53662a33.svg";
export { ForwardRef as ReactComponent };